import { Component } from 'react';

class ForScreen extends Component {
  state = {
    screenWidth: window.innerWidth
  };

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ screenWidth: window.innerWidth });
  };

  windowSize = () => {
    const { mobile, desktop } = this.props;

    if (mobile) return this.state.screenWidth < 767;
    if (desktop) return this.state.screenWidth > 767;

    return true;
  };

  render() {
    if (this.windowSize()) {
      return this.props.children ? this.props.children : null;
    }
    return null;
  }
}

export default ForScreen;



// WEBPACK FOOTER //
// ./src/Containers/ForScreen.js